import {
  list_of_default
} from "./chunk-J7NOTWJ6.js";

// src/modules/list-of/list-of.tsx
import { jsx } from "react/jsx-runtime";
var mListOf = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  if (!content?.first && !content?.second && !content?.third && !content?.fourth)
    return null;
  return /* @__PURE__ */ jsx(
    "section",
    {
      className,
      "data-module-sequence": sequence,
      "data-module-type": "mListOf",
      id: _id,
      children: /* @__PURE__ */ jsx(list_of_default, { id: `${_id}_list_of`, ...content })
    }
  );
};
var list_of_default2 = mListOf;

export {
  list_of_default2 as list_of_default
};
